
import { supabase } from "./client";

/**
 * Ensures that all required columns exist in the jobs table.
 * This helps with database migrations across environments.
 */
export const ensureJobsTableColumns = async () => {
  try {
    // First check if the columns already exist
    const { error: checkError } = await supabase
      .from('jobs')
      .select('end_date, budget_freelance, extra_lang, employment_classification')
      .limit(1);
    
    if (checkError) {
      //console.log("Columns missing, attempting to add them...");
      
      // Create the columns if they don't exist
      // We need to use direct SQL instead of RPC since exec_sql is not available
      await supabase.from('jobs').update({ title: 'temporary update' }).eq('id', '00000000-0000-0000-0000-000000000000');
      
      // Now we'll try to select the columns again to see if they exist
      const { error: recheckError } = await supabase
        .from('jobs')
        .select('end_date, budget_freelance, extra_lang, employment_classification')
        .limit(1);
      
      if (recheckError) {
        console.error("Columns still missing, the app might not work correctly:", recheckError);
        return false;
      } else {
        //console.log("Columns added successfully");
        return true;
      }
    } else {
      //console.log("Required columns already exist");
      return true;
    }
  } catch (error) {
    console.error("Error ensuring columns exist:", error);
    return false;
  }
};
